var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-layout"},[_c('aside',[_c('div',{staticClass:"payment-layout__header"},[_vm._t("header")],2),_vm._t("payment-methods"),_vm._t("cart")],2),(_vm.$slots.default)?_c('main',{staticClass:"payment-layout__main"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }